import { extendTheme, ThemeConfig } from "@chakra-ui/react";
import semanticTokens from "./semanticTokens";
import Button from "./buttons";
import fonts from "./fonts";
import textStyles from "./text";
import styles from "./styles";
import customIcons from "./icons";
import Table from "./table";
import Heading from "./heading";

const config: ThemeConfig = {
  initialColorMode: "light", // or "dark" if you want dark by default
  useSystemColorMode: false // don't follow system setting
};

// Extra breakpoints above Chakra's default "2xl" (1536px) so text scales
// gradually across common desktop/laptop resolutions instead of jumping
// straight from ~1366px (design baseline) to whatever the viewport is.
const breakpoints = {
  "2xl": "90em", // 1440px
  "3xl": "100em", // 1600px
  "4xl": "120em", // 1920px
  "5xl": "160em" // 2560px
};

export const overrides = {
  config,
  styles,
  semanticTokens,
  textStyles,
  fonts,
  breakpoints,
  icons: {
    ...customIcons
  },

  components: {
    Button,
    Table,
    Heading

    // Other components go here
  }
};

export default extendTheme(overrides);
